import React, { Component } from "react";
import { exportComponentAsPNG } from "react-component-export-image";
import "./style1.css";

class App extends Component {
  certificateWrapper = React.createRef();
  state = {
    Name: "",
  };
  render() {
    return (
      <div className="App">
        <div className="Meta">
          <h1 class="text-center mt-12">GENERER UNE ATTESTION</h1>
          <p>Veuillez ajouter un nom</p>
          <input 
            type="text"
            placeholder="Please enter your name..."
            value={this.state.Name}
            onChange={(e) => {
              this.setState({ Name: e.target.value });
            }}
          />
          <button
            onClick={(e) => {
              e.preventDefault();
              exportComponentAsPNG(this.certificateWrapper, {
                html2CanvasOptions: { backgroundColor: null },
              });
            }}
          >
            Download
          </button>
        </div>

        <div id="downloadWrapper" ref={this.certificateWrapper}>
          <div className="text-center" id="certificateWrapper">
            <p>{this.state.Name}</p>
            <img
              src=".././images/Modèle_Attestation_site.png"
              alt="Certificate"
              width="800px"
            />
          </div>
        </div>
      </div>
    );
  }
}

export default App;
